import { render, staticRenderFns } from "./memberComEditorComponent.vue?vue&type=template&id=504c0198&"
import script from "./memberComEditorComponent.vue?vue&type=script&lang=js&"
export * from "./memberComEditorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports